import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const NextIcon = ({ label = 'Next', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path style="fill:#b1ce5f" d="M88 59.9v180.2l108.2-90.4L88 59.9z"/><path d="m88 59.9 108.2 89.8L88 240.1V59.9m0-10a9.9 9.9 0 0 0-10 10v180.2a10.1 10.1 0 0 0 5.8 9.1 10.2 10.2 0 0 0 4.2.9 10 10 0 0 0 6.4-2.3l108.2-90.5a9.9 9.9 0 0 0 3.6-7.7 10.2 10.2 0 0 0-3.6-7.6L94.4 52.2a10 10 0 0 0-6.4-2.3z" style="fill:#1d1d1b"/><path d="M143.3 174.3a4.9 4.9 0 0 1-3.2-1.6 4.6 4.6 0 0 1 .5-6.6l23.5-20.6a4.6 4.6 0 0 1 6.6.5 4.7 4.7 0 0 1-.4 6.6l-23.6 20.6a4.7 4.7 0 0 1-3.4 1.1zm-26.6 23.3a4.5 4.5 0 0 1-3.2-1.6 4.7 4.7 0 0 1 .4-6.6l4.7-4.1a4.6 4.6 0 0 1 6.6.5 4.7 4.7 0 0 1-.4 6.6l-4.7 4.1a4.8 4.8 0 0 1-3.4 1.1zm95.3 47.5a5 5 0 0 1-5-5V59.9a5 5 0 0 1 5-5 5 5 0 0 1 5 5v180.2a5 5 0 0 1-5 5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

NextIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { NextIcon }
